import * as Yup from 'yup';

import { MAX_FILE_SIZE_30MB } from '@/common/constants';

export const editSireReviewAdminSchema = (dataDetail?: { reviewStatus?: number; isRerequest?: boolean }) =>
    Yup.object({
        assignReviewer: Yup.string()
            .trim()
            .required('Assign reviewer is required'),
        OCIMFSireReportFile: Yup.mixed()
            .when('isRerequest', {
                is: () => dataDetail?.isRerequest === false,
                then: schema => schema.required('OCIMF sire report file is required'),
                otherwise: schema => schema,
            })
            .test('fileSize', 'File size is too large', (value) => {
                if (value && (value as File).size > MAX_FILE_SIZE_30MB) {
                    return false;
                }
                return true;
            }),
        OfficerMatrixFile: Yup.mixed()
            .when('isRerequest', {
                is: () => dataDetail?.isRerequest === false,
                then: schema => schema.required('Officer matrix file is required'),
                otherwise: schema => schema,
            })
            .test('fileSize', 'File size is too large', (value) => {
                if (value && (value as File).size > MAX_FILE_SIZE_30MB) {
                    return false;
                }
                return true;
            }),
    });
